import { Text } from 'bold-ui'
import { TipoAtendimentoProfissional } from 'graphql/types.generated'

import { TIPOS_ATENDIMENTO_RETIFICAVEIS_RNDS } from './util-retificacaoAtendimento'

interface AlertaRetificacaoAtendimentoTextProps {
  tipoAtendimentoProfissional: TipoAtendimentoProfissional
}

export function AlertaRetificacaoAtendimentoText(props: Readonly<AlertaRetificacaoAtendimentoTextProps>) {
  const { tipoAtendimentoProfissional } = props

  const tipoAtendimentoEnviaRnds = TIPOS_ATENDIMENTO_RETIFICAVEIS_RNDS.has(tipoAtendimentoProfissional)

  return (
    <Text color='inherit'>
      Todos os registros adicionados, editados e removidos na retificação serão enviados para a base nacional
      {tipoAtendimentoEnviaRnds && ' e para a RNDS'}.{' '}
      <Text color='inherit' fontWeight='bold'>
        As alterações poderão ser visualizadas na Trilha de Auditoria do PEC e-SUS APS e impressas através do histórico
        do cidadão.
      </Text>
    </Text>
  )
}
